<template>
	<div class="forward">
		<div class="forward_title">企业商标有效注册量TOP50</div>
		<vue-seamless-scroll :data="regList" :class-option="optionSingleHeightTime" class="seamless-warp">
			<div class="regList" v-for="(item,index) in regList" :key="index">
				<div class="regItem">
					<div class="regItem_title">
						<div class="index">{{index + 1}}</div>
						<div class="title">{{item.sb_qy_youx_top_name}}</div>
					</div>
					<div class="regItem_num">{{item.sb_qy_youx_top_num}}</div>
				</div>
				<el-progress :percentage="Number(item.pec)" :show-text="false"></el-progress>
			</div>
		</vue-seamless-scroll>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				regList:[]
			}
		},
		computed: {
			optionSingleHeightTime () {
				return {
					singleHeight:54,
					waitTime:3000
				}
			}
		},
		mounted() {},
		methods:{
			getData(list){
				this.regList = list
				var max = list[0].sb_qy_youx_top_num
				for(var i in list){
					list[i].pec = ((list[i].sb_qy_youx_top_num / max) * 100).toFixed(2)
				}
			},
		},
	}
</script>

<style  scoped>
	
</style>